import { inject, Injectable } from '@angular/core';
import { AsyncHttpClient } from './async-http-client.service';
import { AppId, ProductElement } from '../../model';

@Injectable({ providedIn: 'root' })
export class ProductElementService {
  private http = inject(AsyncHttpClient);

  list = async (productId: AppId) => this.http.get<ProductElement[]>(`api/chain/${productId}/element`);

  create = async (productId: AppId, data: { name: string; description?: string | null; levelId: AppId }) =>
    this.http.post<ProductElement>(`api/chain/${productId}/element`, data);

  update = async (
    productId: AppId,
    elementId: AppId,
    data: { name: string; description?: string | null; levelId: AppId }
  ) => this.http.put<ProductElement>(`api/chain/${productId}/element/${elementId}`, data);

  delete = async (productId: AppId, elementId: AppId) =>
    this.http.delete<void>(`api/chain/${productId}/element/${elementId}`);

  linkDocument = async (productId: AppId, elementId: AppId, documentId: AppId) =>
    this.http.post<ProductElement>(`api/chain/${productId}/element/${elementId}/document`, { documentId });

  unlinkDocument = async (productId: AppId, elementId: AppId, docId: AppId) =>
    this.http.delete<ProductElement>(`api/chain/${productId}/element/${elementId}/document/${docId}`);
}
